import { 
  Rocket, 
  LineChart, 
  Shield, 
  Users, 
  Zap, 
  Lock,
  ArrowRight
} from "lucide-react";
import { Link } from "react-router-dom";

const features = [
  {
    icon: Rocket,
    title: "Fair Launch",
    description: "No presales, no insider allocations. Every token starts on an equal footing with bonding curve mechanics.",
    color: "text-primary",
  },
  {
    icon: LineChart,
    title: "Bonding Curve Trading",
    description: "Automated price discovery using constant product formula. Buy and sell instantly with guaranteed liquidity.",
    color: "text-accent",
  },
  {
    icon: Lock,
    title: "Lock & Unlock",
    description: "Coins start locked until target market cap is reached. Community votes to unlock for open trading.",
    color: "text-warning",
  },
  {
    icon: Shield,
    title: "Secure & Transparent",
    description: "All trades are on-chain and verifiable. Smart contracts audited for maximum security.",
    color: "text-success",
  },
  {
    icon: Users,
    title: "Community Driven",
    description: "Voting power for token holders and verified streamers. Your voice matters in unlock decisions.",
    color: "text-primary",
  },
  {
    icon: Zap,
    title: "Instant Settlement",
    description: "Powered by Solana for sub-second finality. Trade at lightning speed with minimal fees.",
    color: "text-accent",
  },
];

export function FeaturesSection() {
  return (
    <section className="py-16 border-t border-border/50">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Why <span className="gradient-text">TheMoonRun</span>?
          </h2>
          <p className="text-muted-foreground">
            Built for degens, by degens. The most transparent and fair meme coin launchpad on Solana.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className="group p-6 rounded-xl bg-card border border-border/50 hover:border-primary/30 transition-all duration-300 hover-lift animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className={`inline-flex p-3 rounded-lg bg-secondary mb-4 ${feature.color}`}>
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 p-8 rounded-2xl bg-gradient-to-r from-primary/20 via-accent/10 to-primary/20 border border-primary/20 text-center">
          <h3 className="font-display text-2xl font-bold text-foreground mb-3">
            Ready to Launch?
          </h3>
          <p className="text-muted-foreground mb-6 max-w-lg mx-auto">
            Create your meme coin in minutes. No coding required. Just connect your wallet and let the community decide your moon.
          </p>
          <Link
            to="/create"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors glow-primary group"
          >
            Start Creating
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
